import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-0c42039d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "site-footer__inner" }
const _hoisted_2 = { class: "site-footer__grid" }
const _hoisted_3 = { class: "site-footer__brand" }
const _hoisted_4 = { class: "site-footer__brand-name" }
const _hoisted_5 = { class: "site-footer__tagline" }
const _hoisted_6 = { class: "site-footer__contact" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = ["href"]
const _hoisted_10 = { key: 2 }
const _hoisted_11 = ["href"]
const _hoisted_12 = { class: "site-footer__social" }
const _hoisted_13 = ["aria-label"]
const _hoisted_14 = ["aria-label"]
const _hoisted_15 = {
  href: "https://www.instagram.com",
  target: "_blank",
  rel: "noopener noreferrer",
  "aria-label": "Instagram"
}
const _hoisted_16 = { class: "site-footer__bottom" }

import { computed, onMounted, ref, watch } from 'vue'
import store from '@/store'
import commons from '@/utils/Common'
import { apiRedis } from '@/api/index'
import { DEFAULT_FOTTER } from '@/const/ApiRedis'
import {
  EnvironmentOutlined,
  PhoneOutlined,
  MailOutlined,
  FacebookOutlined,
  InstagramOutlined,
  GoogleOutlined,
} from '@ant-design/icons-vue'
import { useI18n } from 'vue-i18n'
import {
  ABOUT,
  CAREERS,
  CART,
  CONTACT,
  DELIVERY_POLICY,
  FAQ_PATH,
  HOME,
  HOW_TO_ORDER,
  LOGIN,
  ORDERS,
  PAYMENT_GUIDE,
  REGISTER,
  RETURN_POLICY,
  SHIPPING_POLICY,
  STORES,
  WARRANTY_GUIDE,
} from '@/const/path'

type FooterLink = { label: string; to: string }
type FooterColumn = { title: string; links: FooterLink[] }


export default /*#__PURE__*/_defineComponent({
  __name: 'DefaultFooter',
  setup(__props) {

const { t, te } = useI18n()

const FOOTER_LABEL_KEYS: Record<string, string> = {
  'tài khoản': 'text.account',
  'tai khoan': 'text.account',
  'chăm sóc khách hàng': 'text.customerSupport',
  'cham soc khach hang': 'text.customerSupport',
  'đăng nhập': 'text.login',
  'dang nhap': 'text.login',
  'sign in': 'text.login',
  'đăng ký': 'text.register',
  'dang ky': 'text.register',
  'sign up': 'text.register',
  'giỏ hàng': 'text.cart',
  'gio hang': 'text.cart',
  cart: 'text.cart',
  'kiểm tra đơn hàng': 'text.trackOrder',
  'kiem tra don hang': 'text.trackOrder',
  'track order': 'text.trackOrder',
  'check order': 'text.trackOrder',
  'hướng dẫn mua hàng': 'text.howToOrder',
  'huong dan mua hang': 'text.howToOrder',
  'how to order': 'text.howToOrder',
  'hướng dẫn thanh toán': 'text.paymentGuide',
  'huong dan thanh toan': 'text.paymentGuide',
  'payment guide': 'text.paymentGuide',
  'phương thức thanh toán': 'text.paymentMethods',
  'phuong thuc thanh toan': 'text.paymentMethods',
  'chính sách đổi trả': 'text.returnExchangePolicy',
  'chinh sach doi tra': 'text.returnExchangePolicy',
  'return & exchange policy': 'text.returnExchangePolicy',
  'hướng dẫn đổi trả': 'text.returnGuide',
  'huong dan doi tra': 'text.returnGuide',
  'hướng dẫn bảo hành': 'text.warrantyGuide',
  'huong dan bao hanh': 'text.warrantyGuide',
  'warranty guide': 'text.warrantyGuide',
  'chính sách bảo hành': 'text.warrantyPolicy',
  'chinh sach bao hanh': 'text.warrantyPolicy',
  'chính sách giao hàng': 'text.deliveryPolicy',
  'chinh sach giao hang': 'text.deliveryPolicy',
  'delivery policy': 'text.deliveryPolicy',
  'chính sách vận chuyển': 'menu.shippingPolicy',
  'chinh sach van chuyen': 'menu.shippingPolicy',
  'shipping policy': 'menu.shippingPolicy',
  'câu hỏi thường gặp': 'text.faq',
  'cau hoi thuong gap': 'text.faq',
  faq: 'text.faq',
  'giới thiệu': 'text.aboutUs',
  'gioi thieu': 'text.aboutUs',
  'về kima home': 'text.aboutKimaHome',
  've kima home': 'text.aboutKimaHome',
  'about kima home': 'text.aboutKimaHome',
  'hệ thống cửa hàng': 'text.storeLocations',
  'he thong cua hang': 'text.storeLocations',
  'store locations': 'text.storeLocations',
  'khuyến mại': 'text.promotions',
  'khuyen mai': 'text.promotions',
  'tuyển dụng': 'text.careers',
  'tuyen dung': 'text.careers',
  careers: 'text.careers',
  'liên hệ': 'text.contact',
  'lien he': 'text.contact',
  'contact us': 'text.contact',
  'cam kết sản phẩm chính hãng': 'text.authenticCommitment',
  'cam ket san pham chinh hang': 'text.authenticCommitment',
  'chính sách bảo mật': 'text.privacyPolicyTitle',
  'chinh sach bao mat': 'text.privacyPolicyTitle',
  'sản phẩm': 'text.products',
  'san pham': 'text.products',
  'bộ sưu tập': 'text.collections',
  'bo suu tap': 'text.collections',
  'trang chủ': 'text.home',
  'trang chu': 'text.home',
  'đơn hàng': 'text.allOrders',
  'don hang': 'text.allOrders',
}

const normalizeLabel = (label: string) =>
  label
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/đ/g, 'd')
    .replace(/Đ/g, 'd')
    .trim()
    .toLowerCase()

const translateLabel = (label?: string) => {
  if (!label) return ''
  if (label.includes('.')) return te(label) ? t(label) : label
  const key = FOOTER_LABEL_KEYS[normalizeLabel(label)]
  return key ? t(key) : label
}

const linkKey = (label: string, to: string) =>
  `${normalizeLabel(label)}|${(to || HOME).toLowerCase()}`

const companys = ref({
  summary: '',
  sub_name: '',
  address: '',
  phone: '',
  name: '',
  description: '',
  logo: '',
  id: null as number | null,
  email: '',
})

const brandName = computed(() => {
  const raw = companys.value.sub_name || companys.value.name || 'KIMAHOME'
  return String(raw).toUpperCase()
})

const brandTagline = computed(() => {
  const s = (companys.value.summary || '').trim()
  if (s && s.length <= 40) return s.toUpperCase()
  return t('text.luxuryFurniture').toUpperCase()
})

const menuFooter = ref<any[]>([])

const fallbackColumns = computed<FooterColumn[]>(() => [
  {
    title: t('text.account'),
    links: [
      { label: t('text.login'), to: LOGIN },
      { label: t('text.register'), to: REGISTER },
      { label: t('text.cart'), to: CART },
      { label: t('text.trackOrder'), to: ORDERS },
    ],
  },
  {
    title: t('text.customerSupport'),
    links: [
      { label: t('text.contact'), to: CONTACT },
      { label: t('text.howToOrder'), to: HOW_TO_ORDER },
      { label: t('text.paymentGuide'), to: PAYMENT_GUIDE },
      { label: t('text.faq'), to: FAQ_PATH },
      { label: t('text.warrantyGuide'), to: WARRANTY_GUIDE },
    ],
  },
  {
    title: t('text.aboutKimaHome'),
    links: [
      { label: t('text.aboutKimaHome'), to: ABOUT },
      { label: t('text.storeLocations'), to: STORES },
      { label: t('text.returnExchangePolicy'), to: RETURN_POLICY },
      { label: t('menu.shippingPolicy'), to: SHIPPING_POLICY },
      { label: t('text.deliveryPolicy'), to: DELIVERY_POLICY },
      { label: t('text.careers'), to: CAREERS },
    ],
  },
])

const mapLink = (item: any): FooterLink | null => {
  const label = translateLabel(item?.linkLabel || item?.label || item?.name)
  if (!label) return null
  return {
    label,
    to: item?.linkTo || item?.to || item?.path || '/',
  }
}

const dedupeLinks = (links: FooterLink[]) => {
  const seen = new Set<string>()
  return links.filter((link) => {
    const routeKey = (link.to || '/').toLowerCase()
    const key = linkKey(link.label, link.to)
    if (seen.has(key) || [...seen].some((s) => s.endsWith(`|${routeKey}`))) {
      return false
    }
    seen.add(key)
    return true
  })
}

const normalizeMenuColumns = (raw: any[]): FooterColumn[] => {
  if (!Array.isArray(raw) || !raw.length) return []

  const grouped = raw
    .map((menu) => {
      const children = Array.isArray(menu?.children) ? menu.children : []
      const links = dedupeLinks(
        children.map(mapLink).filter(Boolean) as FooterLink[],
      )
      const title = translateLabel(menu?.linkLabel || menu?.label || menu?.name)
      if (!title || !links.length) return null
      return { title, links }
    })
    .filter(Boolean) as FooterColumn[]

  if (grouped.length) return grouped.slice(0, 3)

  const flat = dedupeLinks(raw.map(mapLink).filter(Boolean) as FooterLink[])
  if (!flat.length) return []

  const size = Math.ceil(flat.length / 3) || 1
  const titles = [
    t('text.account'),
    t('text.customerSupport'),
    t('text.aboutKimaHome'),
  ]
  return [0, 1, 2]
    .map((i) => {
      const links = flat.slice(i * size, i * size + size)
      if (!links.length) return null
      return { title: titles[i], links }
    })
    .filter(Boolean) as FooterColumn[]
}

const footerColumns = computed(() => {
  const normalized = normalizeMenuColumns(menuFooter.value)
  return normalized.length ? normalized : fallbackColumns.value
})

onMounted(() => {
  loadMenuFooter()
  cokiesCompany()
})

const cokiesCompany = () => {
  const data = commons.getCokiesCompany()
  if (data) companys.value = data
}

const isLCompanyInfor = computed(() => store.getters.isLCompanyInfor)
watch(isLCompanyInfor, () => {
  cokiesCompany()
})

const loadMenuFooter = async () => {
  try {
    const res: any = await apiRedis(DEFAULT_FOTTER)
    let data = res?.data?.data
    if (typeof data === 'string') data = JSON.parse(data)
    menuFooter.value = Array.isArray(data) ? data : []
  } catch {
    menuFooter.value = []
  }
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_layout_footer = _resolveComponent("a-layout-footer")!

  return (_openBlock(), _createBlock(_component_a_layout_footer, { class: "site-footer" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("section", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(brandName.value), 1),
            _createElementVNode("p", _hoisted_5, _toDisplayString(brandTagline.value), 1),
            _createElementVNode("ul", _hoisted_6, [
              (companys.value.address)
                ? (_openBlock(), _createElementBlock("li", _hoisted_7, [
                    _createVNode(_unref(EnvironmentOutlined)),
                    _createElementVNode("span", null, _toDisplayString(companys.value.address), 1)
                  ]))
                : _createCommentVNode("", true),
              (companys.value.phone)
                ? (_openBlock(), _createElementBlock("li", _hoisted_8, [
                    _createVNode(_unref(PhoneOutlined)),
                    _createElementVNode("a", {
                      href: `tel:${companys.value.phone}`
                    }, _toDisplayString(companys.value.phone), 9, _hoisted_9)
                  ]))
                : _createCommentVNode("", true),
              (companys.value.email)
                ? (_openBlock(), _createElementBlock("li", _hoisted_10, [
                    _createVNode(_unref(MailOutlined)),
                    _createElementVNode("a", {
                      href: `mailto:${companys.value.email}`
                    }, _toDisplayString(companys.value.email), 9, _hoisted_11)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("a", {
                href: "https://www.facebook.com",
                target: "_blank",
                rel: "noopener noreferrer",
                "aria-label": _ctx.$t('text.facebook')
              }, [
                _createVNode(_unref(FacebookOutlined))
              ], 8, _hoisted_13),
              _createElementVNode("a", {
                href: "https://www.google.com",
                target: "_blank",
                rel: "noopener noreferrer",
                "aria-label": _ctx.$t('text.google')
              }, [
                _createVNode(_unref(GoogleOutlined))
              ], 8, _hoisted_14),
              _createElementVNode("a", _hoisted_15, [
                _createVNode(_unref(InstagramOutlined))
              ])
            ])
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(footerColumns.value, (column, index) => {
            return (_openBlock(), _createElementBlock("section", {
              key: `${column.title}-${index}`,
              class: "site-footer__col"
            }, [
              _createElementVNode("h4", null, _toDisplayString(column.title), 1),
              _createElementVNode("ul", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(column.links, (link, linkIndex) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: `${link.to}-${linkIndex}`
                  }, [
                    _createVNode(_component_router_link, {
                      to: link.to
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(link.label), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ]))
                }), 128))
              ])
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('text.copyright')), 1)
        ])
      ])
    ]),
    _: 1
  }))
}
}

})